<template lang="pug">
div
  h1.h3.u-mb-sm.u-lineHeight Button

  CodeSample(name="Types" :pug="buttonTypesPug" :html="buttonTypesHtml" )
    a.button Anchor
    button.button Button
    input.button(type='submit', value='Submit input')
    input.button(type='reset', value='Reset input')


  CodeSample(name="Sizes" :pug="buttonSizesPug" :html="buttonSizesHtml" class="u-mt-md")
    a(class="button is-tiny") .is-tiny
    a(class="button is-small") .is-small
    a(class="button is-normal") .is-normal
    a(class="button is-large") .is-large
    a(class="button is-massive") .is-massive


  CodeSample(name="Colors" :pug="buttonColorsPug" :html="buttonColorsHtml" class="u-mt-md")
    a(class="button is-primary") .is-primary
    a(class="button is-secondary") .is-secondary
    a(class="button is-info") .is-info
    a(class="button is-success") .is-success
    a(class="button is-warning") .is-warning
    a(class="button is-danger") .is-danger
    a(class="button is-black") .is-black
    a(class="button is-white") .is-white


  CodeSample(name="Rounded" :pug="buttonRoundedPug" :html="buttonRoundedHtml" class="u-mt-md")
    a(class="button is-primary is-rounded") .is-rounded
    a(class="button is-secondary is-rounded") .is-rounded
    a(class="button is-info is-rounded") .is-rounded
    a(class="button is-success is-rounded") .is-rounded
    a(class="button is-warning is-rounded") .is-rounded
    a(class="button is-danger is-rounded") .is-rounded
    a(class="button is-black is-rounded") .is-rounded
    a(class="button is-white is-rounded") .is-rounded


  CodeSample(name="Inverse" :pug="buttonInversePug" :html="buttonInverseHtml" class="u-mt-md")
    a(class="button is-primary is-inverse") .is-inverse
    a(class="button is-secondary is-inverse") .is-inverse
    a(class="button is-info is-inverse") .is-inverse
    a(class="button is-success is-inverse") .is-inverse
    a(class="button is-warning is-inverse") .is-inverse
    a(class="button is-danger is-inverse") .is-inverse
    a(class="button is-black is-inverse") .is-inverse
    a(class="button is-white is-inverse") .is-inverse


  CodeSample(name="Icons" :pug="buttonIconsPug" :html="buttonIconsHtml" class="u-mt-md")
    a(class="button is-tiny")
      AppIcon(name="download")
      span .is-tiny
    a(class="button is-small")
      AppIcon(name="download")
      span .is-small
    a(class="button is-normal")
      AppIcon(name="download")
      span .is-normal
    a(class="button is-large")
      AppIcon(name="download")
      span .is-large
    a(class="button is-massive")
      span .is-massive
      AppIcon(name="download")
    br
    a(class="button is-tiny")
      AppIcon(name="download")
    a(class="button is-small")
      AppIcon(name="download")
    a(class="button is-normal")
      AppIcon(name="download")
    a(class="button is-large")
      AppIcon(name="download")
    a(class="button is-massive")
      AppIcon(name="download")


  CodeSample(name="Other" :pug="buttonOtherPug" :html="buttonOtherHtml" class="u-mt-md")
    a(class="button is-block") .is-block
    a(class="button is-active") .is-active
    a(class="button is-disabled") .is-disabled
    a(class="button is-link") .is-link
    a(class="button is-clean") .is-clean


  table.table.is-relaxed.u-mt-md
    thead
      tr
        th Modifier
        th Description
        th Class
    tbody
      tr
        td Color
        td indicates the element state
        td
          p .is-black
          p .is-white
          p .is-primary
          p .is-secondary
          p .is-info
          p .is-success
          p .is-warning
          p .is-danger
      tr
        td Size
        td changes the element size based on font-size
        td
          p .is-tiny
          p .is-small
          p .is-normal
          p .is-large
          p .is-massive
      tr
        td Block
        td the button takes all the container width
        td .is-block
      tr
        td Inverse
        td reverses background and text color
        td .is-inverse
      tr
        td Rounded
        td add rounded corners to a button
        td .is-rounded
      tr
        td Link
        td changes a button to the link shape
        td .is-link
      tr
        td Clean
        td removes button border and background
        td .is-clean
      tr
        td Active
        td indicates active state, equivalent to `button:active`
        td .is-active
      tr
        td Disabled
        td indicates that a button is disabled, equivalent to `button[disabled]`
        td .is-disabled


</template>

<script>
import CodeSample from '~/components/CodeSample';

export default {
  scrollToTop: true,

  layout: 'base',

  head: () => ({
    title: 'Button'
  }),
  components: {
    CodeSample
  },

  data: () => ({
    buttonTypesPug: `a.button Anchor
button.button Button
input.button(type='submit', value='Submit input')
input.button(type='reset', value='Reset input')`,
    buttonTypesHtml: `<a class="button">Anchor</a>
<button class="button">Button</button>
<input type="submit" value="Submit input" class="button"/>
<input type="reset" value="Reset input" class="button"/>`,
    buttonSizesPug: `a(class="button is-tiny") .is-tiny
a(class="button is-small") .is-small
a(class="button is-normal") .is-normal
a(class="button is-large") .is-large
a(class="button is-massive") .is-massive`,
    buttonSizesHtml: `<a class="button is-tiny"> .is-tiny </a>
<a class="button is-small"> .is-small </a>
<a class="button is-normal"> .is-normal </a>
<a class="button is-large"> .is-large </a>
<a class="button is-massive"> .is-massive </a>`,
    buttonColorsPug: `a(class="button is-primary") .is-primary
a(class="button is-secondary") .is-secondary
a(class="button is-info") .is-info
a(class="button is-success") .is-success
a(class="button is-warning") .is-warning
a(class="button is-danger") .is-danger
a(class="button is-black") .is-black
a(class="button is-white") .is-white`,
    buttonColorsHtml: `<a class="button is-primary"> .is-primary </a>
<a class="button is-secondary"> .is-secondary </a>
<a class="button is-info"> .is-info </a>
<a class="button is-success"> .is-success </a>
<a class="button is-warning"> .is-warning </a>
<a class="button is-danger"> .is-danger </a>
<a class="button is-black"> .is-black </a>
<a class="button is-white"> .is-white </a>`,
    buttonIconsPug: `a(class="button is-tiny")
  svg(class="icon" viewbox='0 0 24 24')
    path( d='M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z')
  span .is-tiny
a(class="button is-small")
  svg(class="icon" viewbox='0 0 24 24')
    path( d='M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z')
  span .is-small
a(class="button is-normal")
  svg(class="icon" viewbox='0 0 24 24')
    path( d='M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z')
  span .is-normal
a(class="button is-large")
  svg(class="icon" viewbox='0 0 24 24')
    path( d='M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z')
  span .is-large
a(class="button is-massive")
  span .is-massive
  svg(class="icon" viewbox='0 0 24 24')
    path( d='M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z')

br

a(class="button is-tiny")
  svg(class="icon" viewbox="0 0 24 24")
    path( d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z")
a(class="button is-small")
  svg(class="icon" viewbox='0 0 24 24')
    path( d='M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z')
a(class="button is-normal")
  svg(class="icon" viewbox='0 0 24 24')
    path( d='M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z')
a(class="button is-large")
  svg(class="icon" viewbox='0 0 24 24')
    path( d='M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z')
a(class="button is-massive")
  svg(class="icon" viewbox='0 0 24 24')
    path( d='M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z')`,
    buttonIconsHtml: `<a class="button is-tiny">
   <svg viewBox="0 0 24 24" class="icon">
      <path d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
   </svg>
   <span>.is-tiny</span>
</a>
<a class="button is-small">
   <svg viewBox="0 0 24 24" class="icon">
      <path d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
   </svg>
   <span>.is-small</span>
</a>
<a class="button is-normal">
   <svg viewBox="0 0 24 24" class="icon">
      <path d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
   </svg>
   <span>.is-normal</span>
</a>
<a class="button is-large">
   <svg viewBox="0 0 24 24" class="icon">
      <path d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
   </svg>
   <span>.is-large</span>
</a>
<a class="button is-massive">
   <span>.is-massive</span>
   <svg viewBox="0 0 24 24" class="icon">
      <path d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
   </svg>
</a>
<br>
<a class="button is-tiny">
   <svg viewBox="0 0 24 24" class="icon">
      <path d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
   </svg>
</a>
<a class="button is-small">
   <svg viewBox="0 0 24 24" class="icon">
      <path d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
   </svg>
</a>
<a class="button is-normal">
   <svg viewBox="0 0 24 24" class="icon">
      <path d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
   </svg>
</a>
<a class="button is-large">
   <svg viewBox="0 0 24 24" class="icon">
      <path d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
   </svg>
</a>
<a class="button is-massive">
   <svg viewBox="0 0 24 24" class="icon">
      <path d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path>
   </svg>
</a>`,
    buttonInversePug: `a(class="button is-primary is-inverse") .is-inverse
a(class="button is-secondary is-inverse") .is-inverse
a(class="button is-info is-inverse") .is-inverse
a(class="button is-success is-inverse") .is-inverse
a(class="button is-warning is-inverse") .is-inverse
a(class="button is-danger is-inverse") .is-inverse
a(class="button is-black is-inverse") .is-inverse
a(class="button is-white is-inverse") .is-inverse`,
    buttonInverseHtml: `<a class="button is-primary is-inverse">.is-inverse</a>
<a class="button is-secondary is-inverse">.is-inverse</a>
<a class="button is-info is-inverse">.is-inverse</a>
<a class="button is-success is-inverse">.is-inverse</a>
<a class="button is-warning is-inverse">.is-inverse</a>
<a class="button is-danger is-inverse">.is-inverse</a>
<a class="button is-black is-inverse">.is-inverse</a>
<a class="button is-white is-inverse">.is-inverse</a>`,
    buttonRoundedPug: `a(class="button is-primary is-rounded") .is-rounded
a(class="button is-secondary is-rounded") .is-rounded
a(class="button is-info is-rounded") .is-rounded
a(class="button is-success is-rounded") .is-rounded
a(class="button is-warning is-rounded") .is-rounded
a(class="button is-danger is-rounded") .is-rounded
a(class="button is-black is-rounded") .is-rounded
a(class="button is-white is-rounded") .is-rounded`,
    buttonRoundedHtml: `<a class="button is-primary is-rounded">.is-rounded</a>
<a class="button is-secondary is-rounded">.is-rounded</a>
<a class="button is-info is-rounded">.is-rounded</a>
<a class="button is-success is-rounded">.is-rounded</a>
<a class="button is-warning is-rounded">.is-rounded</a>
<a class="button is-danger is-rounded">.is-rounded</a>
<a class="button is-black is-rounded">.is-rounded</a>
<a class="button is-white is-rounded">.is-rounded</a>`,
    buttonOtherPug: `a(class="button is-block") .is-block
a(class="button is-active") .is-active
a(class="button is-disabled") .is-disabled
a(class="button is-link") .is-link
a(class="button is-clean") .is-clean`,
    buttonOtherHtml: `<a class="button is-block">.is-block</a>
<a class="button is-active">.is-active</a>
<a class="button is-disabled">.is-disabled</a>
<a class="button is-link">.is-link</a>
<a class="button is-clean">.is-clean</a>`
  })
};
</script>

<style lang="stylus" scoped>
.tabs-body
  .button
    margin: 0 unitRes(8, 16) unitRes(8, 16) 0
</style>
